export const openLink = (link) => {
  return window.open(link, '_blank', 'noopener,noreferrer');
};
